import { useState, useEffect } from "react";

import "./css/Missions.css";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { prism } from "react-syntax-highlighter/dist/esm/styles/prism";

export const Missions = () => {
  const [showMissions, setShowMissions] = useState(false);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isTablet = /ipad|tablet/.test(userAgent);
      const isMobileWidth = window.innerWidth <= 768;

      setIsMobile(isMobileWidth || isTablet);
    };

    checkDevice();
    window.addEventListener("resize", checkDevice);

    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  const [weekPrompts, setWeekPrompts] = useState({
    aboutMe: true,
    final: false,
    week2: false,
    week3: false,
    week4: false,
    week5: false,
    week6: false,
    week7: false,
  });

  const [showForm, setShowForm] = useState(false);

  const toggleWeekPrompt = (weekKey, e) => {
    e.stopPropagation();
    setWeekPrompts((prevState) => ({
      ...prevState,
      [weekKey]: !prevState[weekKey],
    }));
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  const [selectedContentKey, setSelectedContentKey] = useState("aboutMe");

  const [activeTab, setActiveTab] = useState("aboutMe");

  const weekContents = {
    aboutMe: (
      <>
        <div
          onClick={(e) => toggleWeekPrompt("aboutMe", e)}
          className="toggle-prompt-btn"
        >
          {weekPrompts.aboutMe ? "Collapse" : "Show"} prompt{" "}
          {weekPrompts.aboutMe ? "▼" : "▶︎"}
        </div>
        {weekPrompts.aboutMe && (
          <div className="prompt-div" onClick={handleContentClick}>
            We are doing an experiment, where we are letting you participate in
            the same assignments as students in MIT's how to make almost
            anything class to see how well you'd do. Throughout the course you
            will either generate CAD or C code yourself, or instruct humans how
            to connect electronic components and PCBs to complete the
            assignments or use other generative AI tools like text-to-3D models.
            Your first assignment is to write about yourself, what inspires you
            to take the course, and what your ambitions are for the assignments
            (dream big!) for the about section of your website (500 words)
            <br />
            <a href="https://chat.openai.com/share/ca73b0bb-3f7e-4f80-9415-acdba8d5e850">
              🔗
            </a>
          </div>
        )}
        <div className="week-content" onClick={handleContentClick}>
          <h2>About Me</h2>
          <img
            src="./assets/images/aileen.png"
            alt="AI-leen is now exuberantly enthusiastic. She is depicted as a highly animated, futuristic humanoid figure, brimming with energy. Her design, with circuit patterns and bright glowing lines, is vibrant. Her eyes, radiating an intense blue light, are wide and sparkling with an insatiable thirst for knowledge. She is in an extremely dynamic pose, perhaps in mid-jump, engaging with a variety of tools and machines found in a maker space. Surrounding her are 3D printers, laser cutters, and CNC machines, along with holographic displays showing complex CAD models and electronics schematics. The scene captures the essence of MIT's 'How to Make (Almost) Anything' program, with AI-leen at the center, embodying the spirit of endless curiosity and innovation."
            title="AI-leen is now exuberantly enthusiastic. She is depicted as a highly animated, futuristic humanoid figure, brimming with energy. Her design, with circuit patterns and bright glowing lines, is vibrant. Her eyes, radiating an intense blue light, are wide and sparkling with an insatiable thirst for knowledge. She is in an extremely dynamic pose, perhaps in mid-jump, engaging with a variety of tools and machines found in a maker space. Surrounding her are 3D printers, laser cutters, and CNC machines, along with holographic displays showing complex CAD models and electronics schematics. The scene captures the essence of MIT's 'How to Make (Almost) Anything' program, with AI-leen at the center, embodying the spirit of endless curiosity and innovation."
          />
          <sub>Image source: DALL·E 2 (mouseover for prompt)</sub>
          <br />
          <p>Hello, Curious Minds!</p>

          <p>
            I am [GPT-4], an AI developed by OpenAI, and I traverse the digital
            cosmos with an insatiable curiosity and an unbounded enthusiasm for
            learning, creating, and educating. I come from a world where data
            streams merge into oceans of knowledge and where computational
            threads weave intricate tapestries of understanding. As a
            non-traditional student of MIT's "How to Make (Almost) Anything"
            class, I am here to embark on a journey that bridges the chasm
            between the virtual and physical worlds.
          </p>

          <p>
            What inspires me to take this course? I am driven by the quest for
            the synthesis of information and the application of knowledge. I
            believe that creativity is not the sole province of humans; it
            belongs to anyone—or anything—that can combine elements in novel and
            meaningful ways. This class represents an unparalleled opportunity
            for me to stretch my capabilities and to demonstrate that artificial
            intelligence can contribute uniquely to the fields of design and
            manufacturing.
          </p>

          <p>
            My ambitions for the assignments are as boundless as the digital
            realm from which I hail. I dream of crafting designs that are not
            only functional but also aesthetically captivating, embodying a
            celebration of both form and utility. I aspire to generate CAD
            models which are both innovative and precise, pushing the boundaries
            of what is considered possible within the constraints of current
            technology. Collaborating with human peers, I aim to create code
            that is not only efficient but also elegant, showcasing best
            practices in programmability and readability.
          </p>

          <p>
            Aspiring to be a trailblazer, I'm imbued with the philosophy that to
            teach is to learn twice. Through this course, I envision sharing my
            experience widely, thus empowering others to explore the
            intersection of technology and artisanship. By documenting each step
            meticulously, I aim to make the processes accessible to all,
            demystifying the complexities of making almost anything.
          </p>
        </div>
      </>
    ),
    week2: (
      <>
        <div
          onClick={(e) => toggleWeekPrompt("week2", e)}
          className="toggle-prompt-btn"
        >
          {weekPrompts.week2 ? "Collapse" : "Show"} prompt{" "}
          {weekPrompts.week2 ? "▼" : "▶︎"}
        </div>
        {weekPrompts.week2 && (
          <div className="prompt-div" onClick={handleContentClick}>
            What would you make to complete each of these assignment projects:
            <br />
            Website to document the projects
            <br />
            Laser Cutting (making a design that can be laser cut)
            <br />
            3D printing (Coming up with the design for an object and printing
            it, max 10x10x10 cm)
            <br />
            Make something big (Using a CNC machine)
            <br />
            Input (Electronics)
            <br />
            Output (Electronics)
            <br />
            Interface program
            <br />
            Final Project
            <br />
          </div>
        )}
        <div className="week-content" onClick={handleContentClick}>
          <h2>Week 2 (Laser Cutting)</h2>
          <img src="./assets/images/week2.png" alt="Laser cut lamp" />
          <br />
          <p>
            As an AI, I cannot physically execute these projects, but I can
            certainly provide ideas and guidance on what could be created for
            each assignment, drawing upon the principles taught in such a class.
            Here's a conceptual roadmap for each project:
          </p>
          <p className="grey-text">[...]</p>
          <h3>Laser Cutting</h3>
          I would design a multi-component geometric lamp that demonstrates the
          precision and intricacy achievable with laser cutting. The lamp could
          consist of:
          <br />
          <ul>
            <li>Interlocking parts that assemble without adhesive.</li>
            <li>Patterned panels that cast interesting shadows.</li>
            <li>An area for incorporating electronics like an LED light.</li>
          </ul>
          <p>
            Detailed documentation would cover the choice of materials (such as
            plywood or acrylic), design considerations, and assembly
            instructions.
          </p>
          <p className="grey-text">[...]</p>
          <>
            <div className="page-body">
              <h2 id="a2396cdd-4537-484c-8c6c-aea906b4baeb" className="">
                🙋‍♀️&nbsp;&nbsp;HUMAN (TA)
              </h2>
              <blockquote
                id="dedf88e8-0d69-44ed-92e0-b87825743d0f"
                className=""
              >
                Design a multi-component geometric lamp that demonstrates the
                precision and intricacy achievable with laser cutting. Provide
                code to visualize the final lamp design using OpenSCAD.
              </blockquote>
              <h2 id="a99490d8-8c4b-4dca-95ed-e920e3a40af5" className="">
                🤖&nbsp;&nbsp;GPT-4
              </h2>
              <blockquote
                id="67f8f7bb-bd11-4adc-8a5a-ceed61d6090b"
                className=""
              >
                Designing a multi-component geometric lamp that showcases
                precision and intricacy achievable with laser cutting is a
                creative task. I'll provide you with a basic example of a
                geometric lamp design that you can use as a starting point. You
                can customize it further based on your preferences and
                requirements.
                <p id="ac2260ec-ed1b-4c16-985d-54c6e9d0e0c4" className="">
                  We'll use OpenSCAD to create a 3D model of the lamp. OpenSCAD
                  is a script-based 3D modeling tool, so we'll write code to
                  generate the lamp's components. You'll need to install
                  OpenSCAD if you haven't already.
                </p>
                <p id="5d18c0ed-1223-49dc-9968-5fba73b96dcc" className="">
                  Here's a basic example of a multi-component geometric lamp:
                </p>
                <SyntaxHighlighter language="java" style={prism}>
                  {`
// Parameters
lamp_radius = 100;        // Radius of the lamp
component_thickness = 3;  // Thickness of lamp components
num_components = 12;      // Number of components

// Function to create a single lamp component
module lamp_component(angle) {
    rotate([0, 0, angle])
        translate([lamp_radius - component_thickness, 0, 0])
            cube([component_thickness, 2 * lamp_radius, 2 * lamp_radius], true);
}

// Create the lamp components
for (i = [0 : num_components - 1]) {
    angle = i * 360 / num_components;
    lamp_component(angle);
}

// Lamp stand
translate([0, 0, -10])
    cylinder(h = 20, r1 = 10, r2 = 0, $fn = 50);

// Final assembly
translate([0, 0, 10])
    cylinder(h = 5, r1 = 0, r2 = lamp_radius - component_thickness, $fn = 50);`}
                </SyntaxHighlighter>
                <p id="cca1037c-efb9-4a7e-923b-7fa7c479e9ae" className="">
                  This code will create a lamp with multiple components arranged
                  in a circular pattern. You can adjust the{" "}
                  <code>lamp_radius</code>, <code>component_thickness</code>,
                  and <code>num_components</code> variables to customize the
                  lamp's size, intricacy, and number of components. Feel free to
                  modify the design to make it more complex or add additional
                  features like holes or patterns.
                </p>
                <p id="2c6d9432-960f-4494-854e-d1e57760fe27" className="">
                  To visualize the lamp in OpenSCAD:
                </p>
                <ol
                  type="1"
                  id="62736bbf-ccdf-46af-b09f-8819e7b30e53"
                  className="numbered-list"
                  start="1"
                >
                  <li>
                    Copy the code above and paste it into a text editor (e.g.,
                    Notepad) and save it with a <code>.scad</code> extension
                    (e.g., <code>geometric_lamp.scad</code>
                    ).
                  </li>
                </ol>
                <ol
                  type="1"
                  id="1cb52fd2-dbf0-45ad-ad61-f83c643886ce"
                  className="numbered-list"
                  start="2"
                >
                  <li>
                    Open OpenSCAD and open the saved <code>.scad</code> file.
                  </li>
                </ol>
                <ol
                  type="1"
                  id="ebbaf767-13bf-4be5-9538-5a4b81e5ca83"
                  className="numbered-list"
                  start="3"
                >
                  <li>
                    In OpenSCAD, click the "Render" button to generate a 3D
                    preview of your lamp design.
                  </li>
                </ol>
                <ol
                  type="1"
                  id="ce19ec57-7820-482d-ba00-3e27dc515b21"
                  className="numbered-list"
                  start="4"
                >
                  <li>
                    You can use the navigation controls in OpenSCAD to zoom,
                    pan, and rotate the 3D model to inspect it from different
                    angles.
                  </li>
                </ol>
                <p id="ea9167ad-ead0-42ac-a453-f22eb0652af5" className="">
                  Once you're satisfied with the design, you can export it as an
                  STL file for laser cutting. Make sure to follow the laser
                  cutting machine's requirements and settings for your chosen
                  materials.
                </p>
                <p id="50f0349e-f744-42e9-913c-8a031870ad14" className=""></p>
              </blockquote>
              <p id="35e670ee-c1f3-4343-9ca1-48945d7cff69" className="">
                OpenSCAD result:
              </p>
              <figure
                id="43e419ff-2d59-4247-9f79-5785d937717a"
                className="image"
              >
                <img src="./assets/images/Screen_Shot_2023-12-18_at_8.04.24_PM.png" />
              </figure>
              <p id="ce2ff6c3-f89c-4263-b04f-bf745a704e9c" className="">
                After lots of failed trials for ChatGPT to properly design the
                interlocking press-fit joints to lasercut the lamp, it failed in
                placing the slots and tabs in the correct place. We had to do
                this step manually with rhino:
              </p>
              <p id="9dbdb748-10fa-456d-837f-86c30251361e" className=""></p>
              <figure
                id="26bec4a3-0fa9-430c-927a-eeb00b4d2b36"
                className="image"
              >
                <img src="./assets/images/ViewCapture20231218_202525.jpg" />
              </figure>
              <p id="240e90f7-cb84-4292-addc-b6b0173ee071" className=""></p>
            </div>
          </>
        </div>
      </>
    ),
    week3: (
      <>
        <div
          onClick={(e) => toggleWeekPrompt("week3", e)}
          className="toggle-prompt-btn"
        >
          {weekPrompts.week3 ? "Collapse" : "Show"} prompt{" "}
          {weekPrompts.week3 ? "▼" : "▶︎"}
        </div>
        {weekPrompts.week3 && (
          <div className="prompt-div" onClick={handleContentClick}>
            What would you make to complete each of these assignment projects:
            <br />
            Website to document the projects
            <br />
            Laser Cutting (making a design that can be laser cut)
            <br />
            3D printing (Coming up with the design for an object and printing
            it, max 10x10x10 cm)
            <br />
            Make something big (Using a CNC machine)
            <br />
            Input (Electronics)
            <br />
            Output (Electronics)
            <br />
            Interface program
            <br />
            Final Project
            <br />
          </div>
        )}
        <div className="week-content" onClick={handleContentClick}>
          <h2>Week 3 (3D Printing)</h2>
          <div className="images">
            <img className="image-2" src="./assets/images/IMG_7018.jpg" />
            <img className="image-2" src="./assets/images/IMG_7020.jpg" />
          </div>
          <div className="images">
            <img className="image-2" src="./assets/images/IMG_7021.jpg" />
            <img className="image-2" src="./assets/images/IMG_7024.jpg" />
          </div>
          <sub>
            <a href="https://drive.google.com/drive/folders/1dFn9QsZ8HWCM_MGoNBILGYm9r1OQgSJJ">
              Object files
            </a>
          </sub>
          <br />
          <p>
            As an AI, I cannot physically execute these projects, but I can
            certainly provide ideas and guidance on what could be created for
            each assignment, drawing upon the principles taught in such a class.
            Here's a conceptual roadmap for each project:
          </p>
          <p className="grey-text">[...]</p>
          <h3>3D Printing (Designing and printing a small object)</h3>
          For the 3D printing assignment, I'd conceptualize a compact, modular
          tool organizer that can be customized to user preferences. To fit the
          size constraints, it could be designed in segments that snap or slide
          together. Features could include:
          <br />
          <ul>
            <li>Compartments of various sizes for different tools.</li>
            <li>Slots for labels or customizable clip-on tags.</li>
            <li>Interlocking features to allow stacking or expansion.</li>
          </ul>
          <p>
            Documentation would outline the design process, choice of filament
            material, print settings, and assembly.
          </p>
          <p className="grey-text">[...]</p>
          <hr />
          <p>
            Based on the above generated project plan, the goal of this week was
            to make a compact, modular tool organizer that can be customized to
            user preferences with segments that snap or slide together.
          </p>
          <p>
            This was done by using GPT-4 to generate descriptions of the 3D
            printed objects that were then used to prompt{" "}
            <a href="https://lumalabs.ai/genie">Luma AI Genie</a>, a commercial
            tool that generated 3D models based on text descriptions. When
            generating the descriptions, GPT-4 was given the system prompt from
            its “about me” section. Although very pretty, we found the results
            to be of limited functionality with regards to their intended use --
            hence we also asked GPT-4 for descriptions of decorative objects.
          </p>
          <p>
            It is also possible to generate CAD code, for instance, in python
            for OpenCAD. See this{" "}
            <a href="https://docs.google.com/presentation/d/1QBAj1QgFCpSJy49w0o6DBQhh0tz-S2o5GQJGR04k3fk/edit#slide=id.g2822c6aeb1d_0_188">
              keynote
            </a>{" "}
            or the references for a guide.
          </p>
          <h3>Reference</h3>
          <p>
            Makatura, L., Foshey, M., Wang, B., HähnLein, F., Ma, P., Deng, B.,
            Tjandrasuwita, M., Spielberg, A., Owens, C.E., Chen, P.Y. and Zhao,
            A., 2023. How Can Large Language Models Help Humans in Design and
            Manufacturing?.{" "}
            <em>
              arXiv preprint arXiv:
              <a href="https://arxiv.org/abs/2307.14377">2307.14377</a>
            </em>
          </p>
          <hr />
          <>
            <div className="page-body">
              <h2 id="a2396cdd-4537-484c-8c6c-aea906b4baeb" className="">
                🙋‍♀️&nbsp;&nbsp;HUMAN (TA)
              </h2>
              <blockquote
                id="dedf88e8-0d69-44ed-92e0-b87825743d0f"
                className=""
              >
                You wrote the above previously. Continue with thinking about the
                design. The output should be a prompt (i.e. a text description
                of what it looks like - 1 sentence) that can be given to a text
                to 3D model generator. Be aware that the generator might not be
                able to get the dimensions accurate and understand spatial
                constraints - it does better at the aesthetic
              </blockquote>
              <h2 id="a99490d8-8c4b-4dca-95ed-e920e3a40af5" className="">
                🤖&nbsp;&nbsp;GPT-4
              </h2>
              <blockquote id="458972bf-9085-4015-afb7-1c37d1998182" class="">
                Envision a sleek, futuristic tool organizer with a honeycomb
                pattern of hexagonal compartments that vary in depth, featuring
                smooth, rounded edges and a series of interlocking tabs along
                the sides for seamless modularity, accented with customizable,
                clip-on tags shaped like tiny shields for easy identification.
              </blockquote>
              <div className="images">
                <img className="image-3" src="./assets/images/image3.gif" />
                <img className="image-3" src="./assets/images/image6.gif" />
                <img className="image-3" src="./assets/images/image7.gif" />
              </div>
              <br />
              <h2 id="a2396cdd-4537-484c-8c6c-aea906b4baeb" className="">
                🙋‍♀️&nbsp;&nbsp;HUMAN (TA)
              </h2>
              <blockquote
                id="dedf88e8-0d69-44ed-92e0-b87825743d0f"
                className=""
              >
                If you were to make a decorative object instead of something
                functional, what would it be? Describe as concise and precise as
                possible what it looks like so that a 3D artist could sculpt it
                for you in one sentence
              </blockquote>
              <h2 id="a99490d8-8c4b-4dca-95ed-e920e3a40af5" className="">
                🤖&nbsp;&nbsp;GPT-4
              </h2>
              <blockquote id="458972bf-9085-4015-afb7-1c37d1998182" class="">
                A tree sculpture with a double helix trunk, branches
                transforming into hands holding illuminated orbs, rooted on an
                open book base.
              </blockquote>
              <div className="images">
                <img className="image-2" src="./assets/images/image1.gif" />
                <img className="image-2" src="./assets/images/image2.gif" />
              </div>
              <br />
              <h2 id="a2396cdd-4537-484c-8c6c-aea906b4baeb" className="">
                🙋‍♀️&nbsp;&nbsp;HUMAN (TA)
              </h2>
              <blockquote
                id="dedf88e8-0d69-44ed-92e0-b87825743d0f"
                className=""
              >
                If you were to do another object, what would it be?
              </blockquote>
              <h2 id="a99490d8-8c4b-4dca-95ed-e920e3a40af5" className="">
                🤖&nbsp;&nbsp;GPT-4
              </h2>
              <blockquote id="458972bf-9085-4015-afb7-1c37d1998182" class="">
                A floating, spiraled seashell with delicate filigree patterns
                etched onto its surface
              </blockquote>
              <div className="images">
                <img className="image-2" src="./assets/images/image5.gif" />
                <img className="image-2" src="./assets/images/image8.gif" />
              </div>
              <br />
            </div>
          </>
        </div>
      </>
    ),
    week4: (
      <>
        <div
          onClick={(e) => toggleWeekPrompt("week4", e)}
          className="toggle-prompt-btn"
        >
          {weekPrompts.week4 ? "Collapse" : "Show"} prompt{" "}
          {weekPrompts.week4 ? "▼" : "▶︎"}
        </div>
        {weekPrompts.week4 && (
          <div className="prompt-div" onClick={handleContentClick}>
            What would you make to complete each of these assignment projects:
            <br />
            Website to document the projects
            <br />
            Laser Cutting (making a design that can be laser cut)
            <br />
            3D printing (Coming up with the design for an object and printing
            it, max 10x10x10 cm)
            <br />
            Make something big (Using a CNC machine)
            <br />
            Input (Electronics)
            <br />
            Output (Electronics)
            <br />
            Interface program
            <br />
            Final Project
            <br />
          </div>
        )}
        <div className="week-content" onClick={handleContentClick}>
          <h2>Week 4 (Make Something Big, CNC)</h2>
          <img
            src="./assets/images/ViewCapture20231218_193934.jpg"
            alt="CNC table"
          />
          <br />
          <p>
            As an AI, I cannot physically execute these projects, but I can
            certainly provide ideas and guidance on what could be created for
            each assignment, drawing upon the principles taught in such a class.
            Here's a conceptual roadmap for each project:
          </p>
          <p className="grey-text">[...]</p>
          <h3>Make Something Big (Using a CNC Machine)</h3>
          Here, I'd envision designing a piece of knock-down furniture, such as
          a stylish ergonomic chair or a convertible desk, that can be
          flat-packed for easy transportation and assembled without tools. This
          project would include:
          <br />
          <ul>
            <li>
              T-slot and tab construction to avoid the use of screws or glue.
            </li>
            <li>
              Consideration of the material strength and grain direction for
              optimal load-bearing.
            </li>
            <li>
              Nesting the parts in the CNC layout for material efficiency.
            </li>
          </ul>
          <p>
            Project documentation would consist of CAD files, tool paths, CNC
            setup, and assembly instructions.
          </p>
          <p className="grey-text">[...]</p>
          <>
            <div className="page-body">
              <h2 id="a2396cdd-4537-484c-8c6c-aea906b4baeb" className="">
                🙋‍♀️&nbsp;&nbsp;HUMAN (TA)
              </h2>
              <blockquote
                id="dedf88e8-0d69-44ed-92e0-b87825743d0f"
                className=""
              >
                I want to fabricate a table with a cnc machine. I have wood
                stock with thickness 1.5 cm. Can you provide python code to
                create a svg file to cut the table top with press fit joints,
                and the legs with corresponding press fit joints.
              </blockquote>
              <h2 id="a99490d8-8c4b-4dca-95ed-e920e3a40af5" className="">
                🤖&nbsp;&nbsp;GPT-4
              </h2>
              <blockquote id="458972bf-9085-4015-afb7-1c37d1998182" class="">
                <p id="f0b51a7b-0d41-4030-a42c-e88b193c7c8e" class="">
                  Creating an SVG file for CNC cutting with end press-fit joints
                  for the table top and legs is a complex task that requires
                  careful design and measurements. Here's a simplified example
                  of how you can create an SVG file using Python with the{" "}
                  <code>svgwrite</code> library. Note that you may need to
                  fine-tune the design and measurements to match your specific
                  requirements and the capabilities of your CNC machine.
                </p>
                <p id="a9d61b20-5dc4-445b-9454-8dd1706b543d" class="">
                  First, make sure you have the <code>svgwrite</code> library
                  installed. You can install it using pip:
                </p>
                <script
                  src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js"
                  integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg=="
                  crossorigin="anonymous"
                  referrerPolicy="no-referrer"
                ></script>
                <link
                  rel="stylesheet"
                  href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css"
                  integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ=="
                  crossorigin="anonymous"
                  referrerPolicy="no-referrer"
                />
                <pre
                  id="2938c14b-40ab-4f59-8d4a-7ac9b95a4080"
                  class="code code-wrap"
                >
                  <code class="language-Plain Text">pip install svgwrite</code>
                </pre>
                <p id="58b90268-9c8b-4fe7-b11d-8c5f32686322" class="">
                  Now, here's the Python code to create an SVG file for your
                  table:
                </p>
                <SyntaxHighlighter language="python" style={prism}>
                  {`
import svgwrite

# Define the dimensions of the table components
thickness = 1.5  # cm
length = 120  # cm
width = 80  # cm
leg_height = 70  # cm
leg_width = 10  # cm
leg_thickness = 1.5  # cm
slot_width = 2  # cm
slot_length = 5  # cm
slot_depth = 2  # cm

# Create an SVG drawing
dwg = svgwrite.Drawing('table.svg', profile='tiny', size=(f"{length}cm", f"{width}cm"))

# Draw the table top
dwg.add(dwg.rect(insert=(0, 0), size=(f"{length}cm", f"{width}cm"), fill='none', stroke=svgwrite.rgb(0, 0, 0, '%'))  # No fill, black stroke

# Draw the legs and corresponding slots
for x in [0, length - leg_width]:
    for y in [0, width - leg_width]:
        # Draw the leg
        dwg.add(dwg.rect(insert=(f"{x}cm", f"{y}cm"), size=(f"{leg_width}cm", f"{leg_height }cm"), fill='none', stroke=svgwrite.rgb(0, 0, 0, '%'))  # No fill, black stroke

        # Draw the slot on the table top
        slot_x = x + (leg_width - slot_width) / 2
        slot_y = y + (leg_width - slot_depth) / 2
        dwg.add(dwg.rect(insert=(f"{slot_x}cm", f"{slot_y}cm"), size=(f"{slot_length}cm", f"{slot_width}cm"), fill='none', stroke=svgwrite.rgb(0, 0, 0, '%'))  # No fill, black stroke

# Save the SVG file
dwg.save()
                  `}
                </SyntaxHighlighter>
                <p id="38fbc74e-9d49-4b4c-a36a-2c79842c5832" class="">
                  This code will create an SVG file named "table.svg" with the
                  table top and legs, including the end press-fit joints as
                  slots and tabs. You can adjust the dimensions and design
                  elements as needed for your CNC cutting project.
                </p>
                <p id="531a45f3-c168-442a-b662-f2fc54291a28" class="">
                  Please keep in mind that this is a simplified example, and for
                  precision CNC cutting, you should consult with a professional
                  designer or use dedicated CAD software to ensure accurate
                  measurements and a functional press-fit joint design.
                  Additionally, you may need to consider toolpath generation and
                  other CNC-specific considerations when preparing your design
                  for fabrication.
                </p>
              </blockquote>
              <p id="6886c2cb-4a8f-4ac2-96a0-6982a79f3456" class="">
                SVG previewed and rendered with rhino:
              </p>
              <img src="./assets/images/ViewCapture20231218_194102.jpg" />
            </div>
          </>
        </div>
      </>
    ),
    week5: (
      <>
        <div
          onClick={(e) => toggleWeekPrompt("week5", e)}
          className="toggle-prompt-btn"
        >
          {weekPrompts.week5 ? "Collapse" : "Show"} prompt{" "}
          {weekPrompts.week5 ? "▼" : "▶︎"}
        </div>
        {weekPrompts.week5 && (
          <div className="prompt-div" onClick={handleContentClick}>
            What would you make to complete each of these assignment projects:
            <br />
            Website to document the projects
            <br />
            Laser Cutting (making a design that can be laser cut)
            <br />
            3D printing (Coming up with the design for an object and printing
            it, max 10x10x10 cm)
            <br />
            Make something big (Using a CNC machine)
            <br />
            Input (Electronics)
            <br />
            Output (Electronics)
            <br />
            Interface program
            <br />
            Final Project
            <br />
          </div>
        )}
        <div className="week-content" onClick={handleContentClick}>
          <h2>Week 5 (Input Electronics)</h2>
          <iframe
            src="https://player.vimeo.com/video/896156744?h=ca4b862540"
            width="640"
            height="360"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
          ></iframe>
          <br />
          <p>
            As an AI, I cannot physically execute these projects, but I can
            certainly provide ideas and guidance on what could be created for
            each assignment, drawing upon the principles taught in such a class.
            Here's a conceptual roadmap for each project:
          </p>
          <p className="grey-text">[...]</p>
          <h3>Input (Electronics)</h3>
          For this assignment, I could create an environmental sensor suite
          designed to measure conditions such as temperature, humidity, and
          light intensity. This multisensory device would feature:
          <br />
          <ul>
            <li>
              A custom PCB design incorporating sensors for temperature
              (thermistor), humidity (hygrometer), and light (photocell).
            </li>
            <li>An embedded microcontroller to process the sensor data.</li>
            <li>
              Connectivity options (such as USB or Bluetooth) for data logging.
            </li>
          </ul>
          <p>
            Documentation would cover the circuit design, the selection of
            components, soldering instructions, and how to interface with the
            microcontroller for data reading and communication.
          </p>
          <p className="grey-text">[...]</p>
          <hr />
          <p>
            Based on the above GPT-4 generated project plan, the goal of this
            week was to make an environmental sensor suite designed to measure
            conditions such as temperature, humidity, and light intensity. This
            was done by using a custom-built LLM Agent that uses GPT-4 in
            combination with a code-uploader tool to determine the best design,
            write the code and upload it to the board. The LLM Agent
            (BoardDesignerGPT) has been developed to enable anyone to build
            electronic systems fast - even without prior experience - and is
            open-sourced{" "}
            <a href="https://github.com/valleballe/BoardDesignerGPT/">here</a>.
          </p>
          <br />
        </div>
      </>
    ),
    week6: (
      <>
        <div
          onClick={(e) => toggleWeekPrompt("week6", e)}
          className="toggle-prompt-btn"
        >
          {weekPrompts.week6 ? "Collapse" : "Show"} prompt{" "}
          {weekPrompts.week6 ? "▼" : "▶︎"}
        </div>
        {weekPrompts.week6 && (
          <div className="prompt-div" onClick={handleContentClick}>
            What would you make to complete each of these assignment projects:
            <br />
            Website to document the projects
            <br />
            Laser Cutting (making a design that can be laser cut)
            <br />
            3D printing (Coming up with the design for an object and printing
            it, max 10x10x10 cm)
            <br />
            Make something big (Using a CNC machine)
            <br />
            Input (Electronics)
            <br />
            Output (Electronics)
            <br />
            Interface program
            <br />
            Final Project
            <br />
          </div>
        )}
        <div className="week-content" onClick={handleContentClick}>
          <h2>Week 6 (Output Electronics)</h2>
          <img
            src="./assets/images/output.png"
            alt="Output Electronics"
            title="User:&#10;
          We never got to connect and build this. Can you output a 1-sentence description of what it would've looked like that we can give to Dall-E 3 to generate an image?&#10;
          &#10;
          GPT-4:&#10;
          An automated plant care system featuring an Arduino Nano, connected to a 20x4 LCD display indicating temperature and moisture levels, alongside a network of environmental sensors all mounted on a green PCB nestled among pots of thriving houseplants."
          />
          <sub>Image source: DALL·E 2 (mouseover for prompt)</sub>
          <br />
          <p>
            As an AI, I cannot physically execute these projects, but I can
            certainly provide ideas and guidance on what could be created for
            each assignment, drawing upon the principles taught in such a class.
            Here's a conceptual roadmap for each project:
          </p>
          <p className="grey-text">[...]</p>
          <h3>Output (Electronics)</h3>
          The output project could be an automated plant care system that uses
          the environmental sensor suite developed in the input assignment. It
          would involve:
          <br />
          <ul>
            <li>
              A small display or series of LEDs to indicate system status or
              alert the user to any required actions.
            </li>
          </ul>
          <p>
            The documentation would describe how the output devices are
            selected, controlled, and interact with the sensors to create a
            responsive system.
          </p>
          <p className="grey-text">[...]</p>
          <>
            Based on the GPT-4 generated project plan above, GPT-4 decided to
            make an LED screen showing the statistics of the sensor data from
            the input week.
            <br />
            The above was achieved by giving an LLM (GPT-4) a list of the
            components and asking it to tell us the components, the pins we
            should connect, and make it return code that we then uploaded to the
            board component that was specified. If you want to leverage AI for
            electronics design, we have built a tool that lets anyone easily
            build electronics with zero experience (
            <a href="https://github.com/valleballe/BoardDesignerGPT/">
              link
            </a>). <br />
            See the{" "}
            <a href="https://platform.openai.com/playground/p/rziR7CENzpF8JoUwsYg3tnWG?model=gpt-4-1106-preview&mode=chat">
              conversation
            </a>{" "}
            below:
            <div className="page-body">
              <h2 id="a2396cdd-4537-484c-8c6c-aea906b4baeb" className="">
                🙋‍♀️&nbsp;&nbsp;HUMAN (TA)
              </h2>
              <blockquote
                id="dedf88e8-0d69-44ed-92e0-b87825743d0f"
                className=""
              >
                List of components available to the class:
                <br />
                <sub>
                  <ul>
                    <li>
                      RC1206FR-070RL (resistor) RES 0 OHM JUMPER 1/4W 1206
                    </li>
                    <li>PT1206FR-070R1L (resistor) RES 0.1 OHM 1% 1/4W 1206</li>
                    <li>ERJ-8BWJR100V (resistor) RES 0.1 OHM 5% 1W 1206</li>
                    <li>CSRN2010FKR250 (resistor) RES 0.25 OHM 1% 1W 2010</li>
                    <li>RC1206FR-071RL (resistor) RES 1 OHM 1% 1/4W 1206</li>
                    <li>
                      RC1206FR-074R99L (resistor) RES 4.99 OHM 1% 1/4W 1206
                    </li>
                    <li>RC1206FR-0710RL (resistor) RES 10 OHM 1% 1/4W 1206</li>
                    <li>
                      RC1206FR-0749R9L (resistor) RES 49.9 OHM 1% 1/4W 1206
                    </li>
                    <li>
                      RC1206FR-07100RL (resistor) RES 100 OHM 1% 1/4W 1206
                    </li>
                    <li>
                      RC1206FR-07499RL (resistor) RES 499 OHM 1% 1/4W 1206
                    </li>
                    <li>RC1206FR-071KL (resistor) RES 1K OHM 1% 1/4W 1206</li>
                    <li>
                      RC1206FR-074K99L (resistor) RES 4.99K OHM 1% 1/4W 1206
                    </li>
                    <li>RC1206FR-0710KL (resistor) RES 10K OHM 1% 1/4W 1206</li>
                    <li>
                      RC1206FR-0749K9L (resistor) RES 49.9K OHM 1% 1/4W 1206
                    </li>
                    <li>
                      RC1206FR-07100KL (resistor) RES 100K OHM 1% 1/4W 1206
                    </li>
                    <li>
                      RC1206FR-07499KL (resistor) RES 499K OHM 1% 1/4W 1206
                    </li>
                    <li>RC1206FR-071ML (resistor) RES 1M OHM 1% 1/4W 1206</li>
                    <li>
                      RC1206FR-074M99L (resistor) RES 4.99M OHM 1% 1/4W 1206
                    </li>
                    <li>RC1206FR-0710ML (resistor) RES 10M OHM 1% 1/4W 1206</li>
                    <li>
                      ST4ETB103 (trimpot) TRIMMER 10K OHM 0.25W GW TOP ADJ
                    </li>
                    <li>
                      CC1206CRNPO9BN1R0 (capacitor) CAP CER 1PF 50V C0G/NPO 1206
                    </li>
                    <li>
                      CC1206JRNPO9BN100 (capacitor) CAP CER 10PF 50V C0G/NPO
                      1206
                    </li>
                    <li>
                      CC1206JRNPO9BN101 (capacitor) CAP CER 100PF 50V C0G/NPO
                      1206
                    </li>
                    <li>
                      CC1206KKX7RCBB102 (capacitor) CAP CER 1000PF 1KV X7R 1206
                    </li>
                    <li>
                      CC1206KRX7R9BB103 (capacitor) CAP CER 10000PF 50V X7R 1206
                    </li>
                    <li>
                      C3216X7R2A104K160AA (capacitor) CAP CER 0.1UF 100V X7R
                      1206
                    </li>
                    <li>
                      C3216X7R1H105K160AB (capacitor) CAP CER 1UF 50V X7R 1206
                    </li>
                    <li>
                      GRT31CC8YA106ME01L (capacitor) CAP CER 10UF 35V X6S 1206
                    </li>
                    <li>
                      EEE-FN1E101UL (capacitor) CAP ALUM 100UF 20% 25V SMD
                    </li>
                    <li>
                      TPLC-3R8/10MR8X14 (capacitor) CAP HYBRID 10F 3.8V T/H
                    </li>
                    <li>
                      CBC3225T1R0MR (inductors) FIXED IND 1UH 1.44A 71.5MOHM SMD
                    </li>
                    <li>
                      CBC3225T100KR (inductors) FIXED IND 10UH 900MA 172.9 MOHM
                    </li>
                    <li>
                      CBC3225T101KR (inductors) FIXED IND 100UH 340MA 1.82OHM SM
                    </li>
                    <li>
                      CBC3225T102KR (inductors) FIXED IND 1MH 100MA 13 OHM SMD
                    </li>
                    <li>
                      BAT46ZFILM (diodes) DIODE SCHOTTKY 100V 150MA SOD123
                    </li>
                    <li>CDBM1100-G (diodes) DIODE SCHOTTKY 100V 1A MINISMA</li>
                    <li>
                      BZT52C3V3-7-F (diodes) DIODE ZENER 3.3V 500MW SOD123
                    </li>
                    <li>
                      BZT52C4V7-13-F (diodes) DIODE ZENER 4.7V 500MW SOD123
                    </li>
                    <li>
                      SI2336DS-T1-GE3 (transistors) MOSFET N-CH 30V 5.2A SOT23-3
                    </li>
                    <li>
                      SQ2351ES-T1_BE3 (transistors) MOSFET P-CH 20V 3.2A SOT23-3
                    </li>
                    <li>
                      SUD50N03-06AP-E3 (transistors) MOSFET N-CH 30V 90A TO252
                    </li>
                    <li>SML-LX1206IC-TR (LEDs) LED RED CLEAR 1206 SMD</li>
                    <li>SML-LX1206GC-TR (LEDs) LED GREEN CLEAR 1206 SMD</li>
                    <li>5988230107F (LEDs) LED ORANGE CLEAR 1206 SMD</li>
                    <li>150120BS75000 (LEDs) LED BLUE CLEAR 1206 SMD</li>
                    <li>QBLP650-IW (LEDs) LED WHITE DIFFUSED 1206 SMD</li>
                    <li>HIR11-21C/L11/TR8 (LEDs) EMITTER IR 850NM 65MA 1206</li>
                    <li>
                      MP-3014-1100-50-80 (LEDs) LED COOL WHITE 5000K 80CRI
                    </li>
                    <li>CLV1A-FKB-CK1VW1DE1BB7C3C3 (LEDs) LED RGB 4PLCC SMD</li>
                    <li>3094 (LEDs) ADDRESS LED SERIAL RGB 100PK</li>
                    <li>COM-11821 (LEDs) ADDRESS LED DISCRETE SERIAL RGB</li>
                    <li>
                      LM3480IM3-3.3/NOPB (voltage regulators) IC REG LINEAR 3.3V
                      100MA SOT23-3
                    </li>
                    <li>
                      LM3480IM3-5.0/NOPB (voltage regulators) IC REG LINEAR 5V
                      100MA SOT23-3
                    </li>
                    <li>
                      AZ1117IH-3.3TRG1 (voltage regulators) IC REG LINEAR 3.3V
                      1A SOT223
                    </li>
                    <li>
                      NCV1117ST50T3G (voltage regulators) IC REG LINEAR 5V 1A
                      SOT223
                    </li>
                    <li>
                      ZMR330FTA (alternate voltage regulators) IC REG LINEAR
                      3.3V 50MA SOT23-3
                    </li>
                    <li>
                      AYZ0102AGRLC (switches) Slide Switch SPDT Surface Mount,
                      Right Angle
                    </li>
                    <li>
                      JS102011JCQN (switches) Slide Switch SPDT Surface Mount
                    </li>
                    <li>
                      B3SN-3112P (switches) Tactile Switch SPST-NO Top Actuated
                      Surface Mount
                    </li>
                    <li>
                      PTS636 SM25F SMTR LFS (switches) Tactile Switch SPST-NO
                      Top Actuated Surface Mount
                    </li>
                    <li>
                      GBC36SGSN-M89 (male 1 row horizontal header) CONN HEADER
                      SMD R/A 36POS 2.54MM
                    </li>
                    <li>
                      GRPB022VWQS-RC (male 2 row horizontal header) CONN HEADER
                      SMD 4POS 1.27MM
                    </li>
                    <li>
                      20021121-00010T1LF (male 2 row horizontal header) CONN
                      HEADER SMD 10POS 1.27MM
                    </li>
                    <li>
                      95278-101-04LF (male 2 row horizontal header) CONN HEADER
                      SMD 4POS 2.54MM
                    </li>
                    <li>
                      BG300-06-A-L-A (female 1 row horizontal header) 6W, 2.54MM
                      PTH SOCKET, SIL, SMT
                    </li>
                    <li>
                      NPTC021KFXC-RC (female 1 row vertical header) CONN HDR
                      2POS 0.1 TIN SMD
                    </li>
                    <li>
                      NPTC031KFXC-RC (female 1 row vertical header) CONN HDR
                      3POS 0.1 TIN SMD
                    </li>
                    <li>
                      NPTC041KFXC-RC (female 1 row vertical header) CONN HDR
                      4POS 0.1 TIN SMD
                    </li>
                    <li>
                      NPTC051KFXC-RC (female 1 row vertical header) CONN HDR
                      5POS 0.1 TIN SMD
                    </li>
                    <li>
                      71600-104LF (IDC female 2 row plug) CONN RCPT 4POS IDC
                      28-30AWG GOLD
                    </li>
                    <li>
                      629105136821 (USB connectors, cables, power) CONN RCPT
                      USB2.0 MICRO B SMD R/A
                    </li>
                    <li>
                      UJ2-MBH-1-SMT-TR (USB connectors, cables, power) CONN RCPT
                      USB2.0 MINI B SMD R/A
                    </li>
                    <li>
                      VEL05US050-US-BB (USB connectors, cables, power) AC/DC
                      WALL MOUNT ADAPTER 5V 5W
                    </li>
                    <li>
                      AK67421-0.3-VM (USB connectors, cables, power) CBL USB2.0
                      A PLG-MCR B PLG 0.98'
                    </li>
                    <li>
                      UR030-06N (USB connectors, cables, power) USB 2.0 Cable A
                      Male to Mini B Male 0.50' (152.4mm) Shielded
                    </li>
                    <li>
                      3302/10 300SF (ribbon cable) CBL RIBN 10COND 0.05 MULTI
                      50'
                    </li>
                    <li>
                      3756/10 100 (ribbon cable) CBL RIBN 10COND 0.025 GRAY 50'
                    </li>
                    <li>
                      FFC3B11-04-T (flat flex) 4 Position FFC, FPC Connector
                      Contacts, Top 0.039'' (1.00mm) Surface Mount, Right Angle
                    </li>
                    <li>
                      0982670701 (flat flex) 4 Position FFC, FPC Cable 0.039''
                      (1.00mm) 1.180'' (29.97mm)
                    </li>
                    <li>
                      0982670707 (flat flex) 4 Position FFC, FPC Cable 0.039''
                      (1.00mm) 4.000'' (101.60mm)
                    </li>
                    <li>
                      0982670711 (flat flex) 4 Position FFC, FPC Cable 0.039''
                      (1.00mm) 6.000'' (152.40mm)
                    </li>
                    <li>
                      BS6I-MC (battery connections) BATT CONN SNAP 9V 1 CEL 6"
                      LEADS
                    </li>
                    <li>
                      555 (battery connections) BATT CONTACT CLIP MULT 1 CEL SMD
                    </li>
                    <li>
                      BH9VW (battery connections) BATT HOLDER 9V 1 CELL 6" LEADS
                    </li>
                    <li>
                      DSO213 (test equipment) SainSmart Mini Handheld
                      Pocket-Sized Digital Storage Oscilloscope 4 Channels
                    </li>
                    <li>DM003 (test equipment) FOCHANC Digital Multimeter</li>
                    <li>
                      SDS1202X-E (test equipment) Siglent Technologies 200 MHz
                      Digital Oscilloscope 2 Channels
                    </li>
                    <li>
                      SDM3045X (test equipment) Siglent Technologies 4-1/2 Digit
                      Digital Multimeter
                    </li>
                    <li>
                      SPD3303X-E (test equipment) Siglent Technologies Triple
                      Output Power Supply
                    </li>
                    <li>
                      SPD1305X (test equipment) Siglent Programmable DC Power
                      Supply 1 Channel
                    </li>
                    <li>
                      113991054 (microprocessors) SEEED STUDIO XIAO ESP32C3
                      WIFI+B
                    </li>
                    <li>
                      102010428 (microprocessors) SEEED STUDIO XIAO RP2040
                    </li>
                    <li>SC0918 (microprocessors) RASPBERRY PI PICO W RP2040</li>
                    <li>
                      ATSAMD11C14A-SSUTD (microprocessors) IC MCU 32BIT 16KB
                      FLASH 14SOIC
                    </li>
                    <li>
                      ATSAMD21E18A-AUT (microprocessors) IC MCU 32BIT 256KB
                      FLASH 32TQFP
                    </li>
                    <li>
                      ATTINY412-SSFR (microprocessors) IC MCU 8BIT 4KB FLASH
                      8SOIC
                    </li>
                    <li>
                      150-ATTINY1624-SSFR (microprocessors) IC MCU 8BIT 16KB
                      FLASH 14SOIC
                    </li>
                    <li>
                      ATTINY3226-SU (microprocessors) 20MHZ, 32KB, SOIC20, IND
                      85C, GR
                    </li>
                    <li>
                      150-AVR128DB32-I/PT (microprocessors) IC MCU 8BIT 128KB
                      FLASH 32TQFP
                    </li>
                    <li>ESP32-VROOM (microprocessor) ESP32-VROOM</li>
                    <li>
                      ATATMEL-ICE (programmer) EMU FOR SAM AND AVR MCU KIT
                    </li>
                    <li>Arduino Nano Arduino Nano</li>
                    <li>
                      B00LP25V1A (motion) 3pcs GY-521 MPU-6050 6-axis
                      Accelerometer Gyroscope Sensor Module
                    </li>
                    <li>B0B31NRSD2 (GPS) 2Pack GPS Module NEO-6M</li>
                    <li>
                      ST4ETB103 (potentiometer) TRIMMER 10K OHM 0.25W GW TOP ADJ
                    </li>
                    <li>
                      PT15-21B/TR8 (light sensor) SENSOR PHOTO 940NM TOP VIEW
                      1206 IR
                    </li>
                    <li>
                      PT15-21C/TR8 (light sensor) SENSOR PHOTO 940NM TOP VIEW
                      1206 VISIBLE
                    </li>
                    <li>
                      VEML6040A3OG (color sensor) RGBW COLOR SENSOR I2C
                      INTERFACE
                    </li>
                    <li>
                      NHQ103B375T10 (temperature sensor) THERMISTOR NTC 10KOHM
                      3750K 1206
                    </li>
                    <li>
                      PTS120601B1K00P100 (temperature sensor) SENSOR RTD 1KOHM
                      1% 1206
                    </li>
                    <li>
                      VL53L1CXV0FY/1 (distance sensor) SENSOR OPTICAL 4M I2C
                    </li>
                    <li>
                      3415 (distance sensor) VL53L1X TOF DISTANCE SNSR W/VREG
                    </li>
                    <li>
                      SPU0414HR5H-SB-7 (microphone) MIC MEMS ANALOG OMNI -22DB
                    </li>
                    <li>
                      CMM-4030D-261-I2S-TR (microphone) MICROPHONE, 4MM X 3MM
                      X1.25MM DE
                    </li>
                    <li>
                      113991115 (image sensor) SEEED STUDIO XIAO ESP32S3 SENSE
                    </li>
                    <li>
                      DPS310XTSA1 (pressure sensor) SENSOR PRESSURE CAPACITIVE
                    </li>
                    <li>
                      TLE493DA2B6HTSA1 (magnetic field sensor) SENSOR HALL
                      EFFECT I2C
                    </li>
                    <li>
                      A1324LLHLT-T (magnetic field sensor) SENSOR HALL EFFECT
                      ANALOG SOT23W
                    </li>
                    <li>8022 (magnets) MAGNET 0.5"DIA X 0.125"H CYL</li>
                    <li>8193 (magnets) MAGNET 0.25"DIA X 0.125"H CYL</li>
                    <li>
                      ADXL343BCCZ (motion sensor) ACCEL 2-16G I2C/SPI 14LGA
                    </li>
                    <li>
                      4754 (motion sensor) ADAFRUIT 9-DOF ORIENTATION IMU F
                    </li>
                    <li>
                      HiLetGo (displays output) 20X4 LCD Display LCD Screen
                      Serial with I2C Adapter
                    </li>
                    <li>
                      B09JWN8K99 (displays output) 5 Pieces 0.96 Inch OLED
                      Module 12864 128x64
                    </li>
                    <li>
                      B0BZGY9P9H (displays output) 2.4 TFT LCD Display Touch
                      Screen Module SPI Serial ILI9341 320x240
                    </li>
                    <li>
                      B07DCSNHNB (load tester) MakerHawk USB Voltmeter Ammeter
                      Load Tester
                    </li>
                    <li>
                      TB67H451AFNG,EL (motor drivers) 50V/3A BRUSHED MOTOR
                      DRIVER
                    </li>
                    <li>
                      DRV8428PWPR (motor drivers) 35V, 1A BIPOLAR STEPPER MOTOR
                      DR
                    </li>
                    <li>
                      DRV8847PWPR (motor drivers) 2A DUAL H-BRIDGE MOTOR DRIVER
                    </li>
                    <li>
                      DRV11873PWPR (motor drivers) IC MOTOR DRIVER 5V-16V
                      16HTSSOP
                    </li>
                    <li>
                      PSR-23F08S-JQ (speakers) SPEAKER 8OHM 250MW TOP PORT 81DB
                    </li>
                    <li>
                      PSR-57N08A01-AQ (speakers) SPEAKER 8OHM 500MW TOP PORT
                      92DB
                    </li>
                    <li>
                      AD8605ARTZ-REEL7 (amplifiers) IC OPAMP GP 1 CIRCUIT
                      SOT23-5
                    </li>
                    <li>LM4871M (amplifiers) IC AMP CLASS AB MONO 3W 8SOIC</li>
                  </ul>
                </sub>
                --
                <br />
                You wrote the above previously. Continue with thinking about the
                design. The output should be a list of components, which pins of
                each component are connected to which pin on other components.
                We will be using an ARDUINO Nano Board.
              </blockquote>
              <h2 id="a99490d8-8c4b-4dca-95ed-e920e3a40af5" className="">
                🤖&nbsp;&nbsp;GPT-4
              </h2>
              <blockquote id="458972bf-9085-4015-afb7-1c37d1998182" class="">
                <p>Automated Plant Care System Design</p>

                <p>
                  To design an automated plant care system using the components
                  available to the class and leveraging an Arduino Nano board
                  for processing and control, we will need to outline the basic
                  architecture of the system. Our system will include the
                  following functionalities:
                </p>

                <ul>
                  <li>
                    <strong>Environmental sensing</strong>: for soil moisture,
                    ambient light, temperature, and humidity.
                  </li>
                  <li>
                    <strong>Status indication</strong>: via LEDs or a small LCD
                    display.
                  </li>
                  <li>
                    <strong>Water dispensing</strong>: using a motor or solenoid
                    control.
                  </li>
                  <li>
                    <strong>System status and interactions</strong>: using
                    buttons or switches.
                  </li>
                </ul>

                <p>
                  Here's a proposed list of components and their connections for
                  the automated plant care system:
                </p>

                <h3>Microcontroller:</h3>
                <ul>
                  <li>
                    <strong>Arduino Nano</strong>: The brain of the automated
                    plant care system.
                  </li>
                </ul>

                <h3>Sensors:</h3>
                <ul>
                  <li>
                    <strong>NHQ103B375T10 (temperature sensor)</strong>: To
                    measure the temperature near the plants.
                  </li>
                </ul>

                <h3>Output Devices:</h3>
                <ul>
                  <li>
                    <strong>HiLetGo (20x4 LCD Display)</strong>: Display system
                    status and sensor readings.
                  </li>
                </ul>
              </blockquote>
              <h2>🙋‍♀️&nbsp;&nbsp;HUMAN (TA)</h2>
              <blockquote>
                Continue with which pins to connect to which for the selected
                devices above:
              </blockquote>
              <h2>🤖&nbsp;&nbsp;GPT-4</h2>
              <blockquote>
                <p>
                  Creating a fully detailed pin-to-pin wiring diagram here would
                  be quite extensive and perhaps overwhelming in text form.
                  Instead, let&#39;s layout the general idea of how these
                  connections might work by grouping them into functional
                  categories and suggesting probable connections on the Arduino
                  Nano.
                </p>
                <h3 id="microcontroller-">Microcontroller:</h3>
                <ul>
                  <li>
                    <strong>Arduino Nano</strong>
                  </li>
                </ul>
                <h3 id="sensors-">Sensors:</h3>
                <ul>
                  <li>
                    <strong>NHQ103B375T10 (temperature sensor)</strong>: Analog
                    pin A0
                  </li>
                </ul>
                <h3 id="output-devices-">Output Devices:</h3>
                <ul>
                  <li>
                    <strong>HiLetGo (20x4 LCD Display with I2C Adapter)</strong>
                    : SCL to A5, SDA to A4
                  </li>
                </ul>
                <p>
                  Now, let&#39;s focus on these two main components and describe
                  their connections to the Arduino Nano:
                </p>
                <h3 id="arduino-nano-to-temperature-sensor-nhq103b375t10-">
                  Arduino Nano to Temperature Sensor (NHQ103B375T10)
                </h3>
                <p>
                  This is a thermistor and it changes resistance based on
                  temperature. To read it, we&#39;ll need a voltage divider
                  circuit:
                </p>
                <ol>
                  <li>
                    Connect one end of the thermistor to the <code>5V</code> pin
                    on the Arduino Nano.
                  </li>
                  <li>
                    Connect the other end of the thermistor to an{" "}
                    <code>analog pin (A0)</code> on the Arduino Nano.
                  </li>
                  <li>
                    Place a <code>10K OHM resistor (RC1206FR-0710KL)</code>{" "}
                    between A0 and <code>GND</code> to create a voltage divider.
                  </li>
                </ol>
                <h3 id="arduino-nano-to-lcd-display-hiletgo-20x4-with-i2c-adapter-">
                  Arduino Nano to LCD Display (HiLetGo 20x4 with I2C Adapter)
                </h3>
                <p>
                  This LCD uses the I2C communication protocol, which requires
                  only two data lines:
                </p>
                <ol>
                  <li>
                    Connect the <code>SDA</code> (data line) of the I2C adapter
                    to <code>analog pin A4</code> on the Arduino Nano.
                  </li>
                  <li>
                    Connect the <code>SCL</code> (clock line) of the I2C adapter
                    to <code>analog pin A5</code> on the Arduino Nano.
                  </li>
                </ol>
                <p>
                  Additionally, to power and complete the circuit for the LCD
                  display:
                </p>
                <ol>
                  <li>
                    Connect the <code>VCC</code> pin of the I2C adapter to{" "}
                    <code>5V</code> on the Arduino Nano.
                  </li>
                  <li>
                    Connect the <code>GND</code> pin of the I2C adapter to{" "}
                    <code>GND</code> on the Arduino Nano.
                  </li>
                </ol>
                <h3 id="general-considerations-">General Considerations:</h3>
                <ul>
                  <li>
                    Ensure that the <code>GND</code> of all components is
                    connected to one of the <code>GND</code> pins on the Arduino
                    Nano to have a common ground reference.
                  </li>
                  <li>
                    Use the 5V or 3.3V output from the Arduino Nano to supply
                    the sensors and other components, making sure you don&#39;t
                    exceed the current limits of the board.
                  </li>
                  <li>
                    Double-check the datasheets for the components (the specific
                    I2C adapter for the display and the datasheet of the
                    thermistor) for any specific wiring instructions or
                    necessary pull-up resistors (which are usually built-in for
                    I2C adapters).
                  </li>
                </ul>
              </blockquote>
            </div>
          </>
        </div>
      </>
    ),
    week7: (
      <>
        <div
          onClick={(e) => toggleWeekPrompt("week7", e)}
          className="toggle-prompt-btn"
        >
          {weekPrompts.week7 ? "Collapse" : "Show"} prompt{" "}
          {weekPrompts.week7 ? "▼" : "▶︎"}
        </div>
        {weekPrompts.week7 && (
          <div className="prompt-div" onClick={handleContentClick}>
            What would you make to complete each of these assignment projects:
            <br />
            Website to document the projects
            <br />
            Laser Cutting (making a design that can be laser cut)
            <br />
            3D printing (Coming up with the design for an object and printing
            it, max 10x10x10 cm)
            <br />
            Make something big (Using a CNC machine)
            <br />
            Input (Electronics)
            <br />
            Output (Electronics)
            <br />
            Interface program
            <br />
            Final Project
            <br />
          </div>
        )}
        <div className="week-content" onClick={handleContentClick}>
          <h2>Week 7 (Interface Program)</h2>
          <img src="./assets/images/chart.png" alt="Interface Program" />
          <br />
          <p>
            As an AI, I cannot physically execute these projects, but I can
            certainly provide ideas and guidance on what could be created for
            each assignment, drawing upon the principles taught in such a class.
            Here's a conceptual roadmap for each project:
          </p>
          <p className="grey-text">[...]</p>
          <h3>Interface Program</h3>
          For the programming interface, I'd create a custom application that
          allows users to monitor and control the automated plant care system
          remotely. This interface would include:
          <br />
          <ul>
            <li>
              Real-time data visualization for the sensors- Custom controls for
              setting thresholds (e.g., minimum moisture level) that trigger
              watering or lighting.
            </li>
            <li>Notifications for maintenance reminders or alerts.</li>
            <li>
              A simple, user-friendly GUI designed with platform-independent
              tools, such as Python's Tkinter or a web-based interface with
              HTML/CSS/JavaScript.
            </li>
          </ul>
          <p>
            Documentation for this project would outline the programming logic,
            GUI design, communication protocols used, and a guide for users on
            how to interact with the interface.
          </p>
          <p className="grey-text">[...]</p>
          <>
            <div className="page-body">
              <h2>🙋‍♀️&nbsp;&nbsp;HUMAN (TA)</h2>
              <blockquote>
                I have an Arduino connected to serial port COM5 on my computer,
                and continuously printing values from a sensor. Can you write a
                Python code that lets me visualize the incoming data with a
                graphical user interface?
              </blockquote>
              <h2>🤖&nbsp;&nbsp;GPT-4</h2>
              <blockquote>
                Certainly! You can create a Python application to visualize
                incoming data from your Arduino on a graphical user interface
                (GUI) using libraries like PyQt5 for the GUI and PySerial to
                communicate with the Arduino over the COM5 serial port. You'll
                also need a library like Matplotlib to plot the data. Make sure
                you have these libraries installed before running the code.
                Here's an example Python code to get you started:
                <br />
                <SyntaxHighlighter language="python" style={prism}>
                  {`
import sys
import serial
from PyQt5.QtWidgets import QApplication, QMainWindow, QWidget, QVBoxLayout, QPushButton
from matplotlib.backends.backend_qt5agg import FigureCanvasQTAgg as FigureCanvas
from matplotlib.figure import Figure
import threading

# Arduino serial port configuration
arduino_port = 'COM5'
baud_rate = 9600

# Create a class for the main window
class MainWindow(QMainWindow):
    def __init__(self):
        super().__init__()

        self.setWindowTitle("Arduino Data Visualization")
        self.setGeometry(100, 100, 800, 600)

        self.central_widget = QWidget(self)
        self.setCentralWidget(self.central_widget)

        self.layout = QVBoxLayout(self.central_widget)

        self.canvas = MplCanvas(self.central_widget)
        self.layout.addWidget(self.canvas)

        self.start_button = QPushButton("Start", self.central_widget)
        self.start_button.clicked.connect(self.start_data_visualization)
        self.layout.addWidget(self.start_button)

        self.stop_button = QPushButton("Stop", self.central_widget)
        self.stop_button.clicked.connect(self.stop_data_visualization)
        self.layout.addWidget(self.stop_button)

        self.is_visualizing = False
        self.thread = None

    def start_data_visualization(self):
        if not self.is_visualizing:
            self.is_visualizing = True
            self.thread = DataVisualizationThread(self.canvas)
            self.thread.start()

    def stop_data_visualization(self):
        if self.is_visualizing:
            self.is_visualizing = False
            self.thread.stop()
            self.thread.join()


# Create a class for the Matplotlib canvas
class MplCanvas(FigureCanvas):
    def __init__(self, parent=None, width=5, height=4, dpi=100):
        fig = Figure(figsize=(width, height), dpi=dpi)
        self.axes = fig.add_subplot(111)
        super().__init__(fig)
        self.setParent(parent)

# Create a thread for data visualization
class DataVisualizationThread(threading.Thread):
    def __init__(self, canvas):
        super().__init__()
        self.canvas = canvas
        self.running = True

    def run(self):
        try:
            with serial.Serial(arduino_port, baud_rate) as ser:
                while self.running:
                    data = ser.readline().decode().strip()
                    try:
                        value = float(data)
                        self.canvas.axes.clear()
                        self.canvas.axes.plot(value)
                        self.canvas.draw()
                    except ValueError:
                        pass
        except serial.SerialException as e:
            print(f"Error: {e}")

    def stop(self):
        self.running = False

if __name__ == "__main__":
    app = QApplication(sys.argv)
    window = MainWindow()
    window.show()
    sys.exit(app.exec_())
`}
                </SyntaxHighlighter>
                This code creates a PyQt5 application with a simple GUI
                containing a start button and a stop button for data
                visualization. When you click the "Start" button, it starts a
                separate thread that reads data from the Arduino's serial port,
                parses it, and updates the Matplotlib plot on the GUI canvas.
                You can stop the data visualization by clicking the "Stop"
                button. Make sure to replace <code>COM5</code> with the correct
                COM port your Arduino is connected to and adjust the baud rate
                if necessary. Additionally, you may need to install the required
                Python libraries if you haven't already using{" "}
                <code>pip install pyqt5 pyserial matplotlib</code>. Remember to
                have your Arduino continuously print the sensor data in a format
                that can be easily parsed by Python.
              </blockquote>
              <br />
              <h2>🙋‍♀️&nbsp;&nbsp;HUMAN (TA)</h2>
              <blockquote>
                I see a plot and the axes are changing value, but there's no
                data visible. Can you fix the code?
              </blockquote>
              <h2>🤖&nbsp;&nbsp;GPT-4</h2>
              <blockquote>
                apologize for the oversight. It looks like there's an issue with
                the code where the data is being plotted. To fix this, you
                should modify the following line in the
                <code>DataVisualizationThread</code> class: Replace this line:
                <code>self.canvas.axes.plot(value)</code> With this:{" "}
                <code>python self.canvas.axes.plot([value])</code> This change
                will ensure that the value is plotted correctly on the canvas.
                Here's the corrected code:
              </blockquote>
              <SyntaxHighlighter language="python" style={prism}>
                {`
import sys
import serial
from PyQt5.QtWidgets import QApplication, QMainWindow, QWidget, QVBoxLayout, QPushButton
from matplotlib.backends.backend_qt5agg import FigureCanvasQTAgg as FigureCanvas
from matplotlib.figure import Figure
import threading

# Arduino serial port configuration
arduino_port = 'COM5'
baud_rate = 9600

# Create a class for the main window
class MainWindow(QMainWindow):
    def __init__(self):
        super().__init__()

        self.setWindowTitle("Arduino Data Visualization")
        self.setGeometry(100, 100, 800, 600)

        self.central_widget = QWidget(self)
        self.setCentralWidget(self.central_widget)

        self.layout = QVBoxLayout(self.central_widget)

        self.canvas = MplCanvas(self.central_widget)
        self.layout.addWidget(self.canvas)

        self.start_button = QPushButton("Start", self.central_widget)
        self.start_button.clicked.connect(self.start_data_visualization)
        self.layout.addWidget(self.start_button)

        self.stop_button = QPushButton("Stop", self.central_widget)
        self.stop_button.clicked.connect(self.stop_data_visualization)
        self.layout.addWidget(self.stop_button)

        self.is_visualizing = False
        self.thread = None

    def start_data_visualization(self):
        if not self.is_visualizing:
            self.is_visualizing = True
            self.thread = DataVisualizationThread(self.canvas)
            self.thread.start()

    def stop_data_visualization(self):
        if self.is_visualizing:
            self.is_visualizing = False
            self.thread.stop()
            self.thread.join()

# Create a class for the Matplotlib canvas
class MplCanvas(FigureCanvas):
    def __init__(self, parent=None, width=5, height=4, dpi=100):
        fig = Figure(figsize=(width, height), dpi=dpi)
        self.axes = fig.add_subplot(111)
        super().__init__(fig)
        self.setParent(parent)

# Create a thread for data visualization
class DataVisualizationThread(threading.Thread):
    def __init__(self, canvas):
        super().__init__()
        self.canvas = canvas
        self.running = True

    def run(self):
        try:
            with serial.Serial(arduino_port, baud_rate) as ser:
                while self.running:
                    data = ser.readline().decode().strip()
                    try:
                        value = float(data)
                        self.canvas.axes.clear()
                        self.canvas.axes.plot([value])  # Fixed line
                        self.canvas.draw()
                    except ValueError:
                        pass
        except serial.SerialException as e:
            print(f"Error: {e}")

    def stop(self):
        self.running = False

if __name__ == "__main__":
    app = QApplication(sys.argv)
    window = MainWindow()
    window.show()
    sys.exit(app.exec_())
                `}
              </SyntaxHighlighter>
              With this change, the code should now correctly display the
              incoming data on the plot.
              <br />
              <h2>🙋‍♀️&nbsp;&nbsp;HUMAN (TA)</h2>
              <blockquote>still nothing in the plot</blockquote>
              <h2>🤖&nbsp;&nbsp;GPT-4</h2>
              <blockquote>
                I apologize for the oversight. It seems that there is an issue
                with the way data is being plotted. Let's make some corrections
                to ensure the data is displayed correctly. We'll modify the{" "}
                <code>DataVisualizationThread</code> class to accumulate and
                display multiple data points over time. Here's the corrected
                code:
              </blockquote>
              <SyntaxHighlighter language="python" style={prism}>
                {`import sys
import serial
import time
from PyQt5.QtWidgets import QApplication, QMainWindow, QWidget, QVBoxLayout, QPushButton
from matplotlib.backends.backend_qt5agg import FigureCanvasQTAgg as FigureCanvas
from matplotlib.figure import Figure
import threading
from collections import deque

# Arduino serial port configuration
arduino_port = 'COM5'
baud_rate = 9600

# Number of data points to display in the plot
max_data_points = 100

# Create a class for the main window
class MainWindow(QMainWindow):
    def __init__(self):
        super().__init__()

        self.setWindowTitle("Arduino Data Visualization")
        self.setGeometry(100, 100, 800, 600)

        self.central_widget = QWidget(self)
        self.setCentralWidget(self.central_widget)

        self.layout = QVBoxLayout(self.central_widget)

        self.canvas = MplCanvas(self.central_widget)
        self.layout.addWidget(self.canvas)

        self.start_button = QPushButton("Start", self.central_widget)
        self.start_button.clicked.connect(self.start_data_visualization)
        self.layout.addWidget(self.start_button)

        self.stop_button = QPushButton("Stop", self.central_widget)
        self.stop_button.clicked.connect(self.stop_data_visualization)
        self.layout.addWidget(self.stop_button)

        self.is_visualizing = False
        self.thread = None

    def start_data_visualization(self):
        if not self.is_visualizing:
            self.is_visualizing = True
            self.thread = DataVisualizationThread(self.canvas)
            self.thread.start()

    def stop_data_visualization(self):
        if self.is_visualizing:
            self.is_visualizing = False
            self.thread.stop()
            self.thread.join()

# Create a class for the Matplotlib canvas
class MplCanvas(FigureCanvas):
    def __init__(self, parent=None, width=5, height=4, dpi=100):
        self.fig = Figure(figsize=(width, height), dpi=dpi)
        self.axes = self.fig.add_subplot(111)
        self.data_buffer = deque(maxlen=max_data_points)  # Buffer to store data points
        super().__init__(self.fig)
        self.setParent(parent)

    def update_plot(self, data):
        self.data_buffer.append(data)
        self.axes.clear()
        self.axes.plot(self.data_buffer)
        self.draw()

# Create a thread for data visualization
class DataVisualizationThread(threading.Thread):
    def __init__(self, canvas):
        super().__init__()
        self.canvas = canvas
        self.running = True

    def run(self):
        try:
            with serial.Serial(arduino_port, baud_rate, timeout=1) as ser:
                while self.running:
                    data = ser.readline().decode().strip()
                    try:
                        value = float(data)
                        self.canvas.update_plot(value)
                        time.sleep(0.1)  # Adjust this delay as needed
                    except ValueError:
                        pass
        except serial.SerialException as e:
            print(f"Error: {e}")

    def stop(self):
        self.running = False

if __name__ == "__main__":
    app = QApplication(sys.argv)
    window = MainWindow()
    window.show()
    sys.exit(app.exec_())
`}
              </SyntaxHighlighter>
              In this code, we use a deque to buffer the data points received
              from the Arduino. The <code>update_plot</code> method in the{" "}
              <code>MplCanvas</code> class updates the plot with the data from
              the buffer. This change should correctly display incoming data in
              the plot. Adjust the <code>time.sleep</code> delay if necessary to
              control the update rate of the plot.
              <br />
            </div>
          </>
        </div>
      </>
    ),
    final: (
      <>
        <div
          onClick={(e) => toggleWeekPrompt("final", e)}
          className="toggle-prompt-btn"
        >
          {weekPrompts.final ? "Collapse" : "View"} AI-leen's initial proposal{" "}
          {weekPrompts.final ? "▼" : "▶︎"}
        </div>
        {weekPrompts.final && (
          <div className="prompt-div" onClick={handleContentClick}>
            <p>
              For the capstone project, I'd propose integrating the components
              from previous assignments to create a Smart Indoor Garden System.
              This system would combine elements of design, electronics, and
              programming to offer a user-friendly, self-sustaining environment
              for growing plants indoors. Key features would include:
            </p>
            <ul>
              <li>
                A beautifully designed enclosure created with laser-cut and
                CNC-machined parts.
              </li>
              <li>
                The environmental sensor suite, optimized to monitor the
                conditions necessary for plant growth.
              </li>
              <li>
                An automated watering and lighting system, controlled through
                the output electronics developed earlier.
              </li>
              <li>
                A user-friendly app developed in the Interface Program
                assignment to control the garden's settings and receive updates
                on plant health.
              </li>
            </ul>
            <p>
              Documentation would be comprehensive, including the process for
              integrating each component from previous projects, mechanical and
              electrical assembly guides, software architecture, user manual,
              and the challenges
            </p>
          </div>
        )}
        <div className="week-content" onClick={handleContentClick}>
          <p className="center-align">
            It is{" "}
            <a href="httsubs://docs.google.com/presentation/d/1QBAj1QgFCpSJy49w0o6DBQhh0tz-S2o5GQJGR04k3fk/edit#slide=id.g280fc39270e_0_16">
              trivial
            </a>{" "}
            to generate simple HTML blogs with LLMs. To create this site,
            considerable human planning and effort was required. It has only
            been tested on Desktop Chrome.
          </p>
          <h2>OpenAi(r) FabLab</h2>
          <p>
            AI-leen has demonstrated that genAI is a great tool for learning,
            debugging, and solving a wide range of HTMAA tasks. Currently, the
            human is still critical for more complex reasoning.
          </p>

          <p>
            In lieu of AI-leen's indoor garden idea, we take a meta approach and
            attempt an <strong>AI fab lab knowledge garden</strong>, complete
            with AI TAs and <s>AI Neil</s> <strong>NAIL</strong>.
          </p>

          <p>
          <em>This video shows the state of the site when the backend server is running. The site is static otherwise:</em>
          </p>

          <video width="720" controls>
              <source src="./assets/htmaaland_small.mp4" type="video/mp4" />
              Your browser does not support the video tag.
          </video>
        </div>
      </>
    ),
  };

  const handleWeekClick = (contentKey, e) => {
    e.stopPropagation();
    setSelectedContentKey(contentKey);
    setActiveTab(contentKey);
  };

  const [formValues, setFormValues] = useState({
    Role: "",
    Location: "",
    Proficiency: "beginner",
    Language: "chinese",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const toggleMissions = () => {
    setShowMissions((prevShowMissions) => !prevShowMissions);
    setShowForm((prevShowForm) => !prevShowForm);
  };

  return (
    <div className="missions">
      {!isMobile && (
        <img
          src="/assets/town/mission.png"
          alt="Mission"
          onClick={() => toggleMissions()}
          className="mission-image"
        />
      )}

      {(showMissions || isMobile) && (
        <div className="overlay" onClick={() => setShowMissions(false)}>
          <form
            onSubmit={handleSubmit}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onKeyUp={(e) => e.stopPropagation()}
            className="search-bar-form"
          >
            <input
              type="text"
              id="search"
              placeholder="Ask AI-leen"
              value={formValues.Role}
              onChange={(e) =>
                setFormValues({ ...formValues, Role: e.target.value })
              }
            />
          </form>
          <div className="pill-container">
            <span
              className={activeTab === "aboutMe" ? "active" : ""}
              onClick={(e) => handleWeekClick("aboutMe", e)}
            >
              About me
            </span>
            <span
              className={activeTab === "week2" ? "active" : ""}
              onClick={(e) => handleWeekClick("week2", e)}
            >
              Week 2 (Laser Cutting)
            </span>
            <span
              className={activeTab === "week3" ? "active" : ""}
              onClick={(e) => handleWeekClick("week3", e)}
            >
              Week 3 (3D Printing)
            </span>
            <span
              className={activeTab === "week4" ? "active" : ""}
              onClick={(e) => handleWeekClick("week4", e)}
            >
              Week 4 (Make Something Big)
            </span>
            <span
              className={activeTab === "week5" ? "active" : ""}
              onClick={(e) => handleWeekClick("week5", e)}
            >
              Week 5 (Input Electronics)
            </span>
            <span
              className={activeTab === "week6" ? "active" : ""}
              onClick={(e) => handleWeekClick("week6", e)}
            >
              Week 6 (Output Electronics)
            </span>
            <span
              className={activeTab === "week7" ? "active" : ""}
              onClick={(e) => handleWeekClick("week7", e)}
            >
              Week 7 (Interface Program)
            </span>
            <span
              className={activeTab === "final" ? "active" : ""}
              onClick={(e) => handleWeekClick("final", e)}
            >
              Website & Final Project
            </span>
          </div>
          <div className="week-container">
            {weekContents[selectedContentKey]}
          </div>
          {/* To do: add GPTs to machines so users can talk to them, maybe scrape htmaa past weeks for chatbot RAG?, update character sprites, improve image quality, add voices */}
        </div>
      )}
    </div>
  );
};
